import "./h-charts.templates.js";

(function () {

    HChartsComponent.$inject = ['$scope', '$element', 'DispatcherServices'];

    function HChartsComponent($scope, $element, DispatcherServices) {

        var self = this;

        var mouseEvent;
        var showTooltipTimeout;
        var activeTooltipGroupIndex;
        var isChartTooltipVisible = false;
        var hideTooltipTimeout;
        var tooltipElm;
        var nunjucks = DispatcherServices.getNunjucks();

        var moveTooltipToEventLocation = function () {
            if (tooltipElm) {
                var top = mouseEvent.pageY - tooltipElm.outerHeight() - 12;
                var left = mouseEvent.pageX - (tooltipElm.outerWidth() / 2);

                if (self.appendChartTooltipTo) {
                    const appendToElm = $(self.appendChartTooltipTo).offset();

                    top -= appendToElm.top;
                    left -= appendToElm.left;
                }

                tooltipElm.removeClass("arrow-to-left");
                tooltipElm.removeClass("arrow-to-right");

                if (left < -20) {
                    left = 0;
                    tooltipElm.addClass("arrow-to-left");
                }
                else {
                    var windowWidth = $(window).width();

                    if ((left + tooltipElm.outerWidth()) > (windowWidth + 20)) {
                        left = windowWidth - tooltipElm.outerWidth();
                        tooltipElm.addClass("arrow-to-right");
                    }
                }

                tooltipElm.css("top", top + "px");
                tooltipElm.css("left", left + "px");
            }
        };

        var getGroupDataByIndex = function (groupIndex) {
            var groupValues = [];
            var chartsData = self.chartsData;

            for (var i in chartsData['data']) {
                var group = chartsData['data'][i];

                if (group.type === 'bars') {
                    for (var j in group.bars) {
                        var bar = group.bars[j];
                        var barValue = bar.values[groupIndex];

                        for (var l in barValue.v) {
                            var valueMap = chartsData.values_map[bar['code'][l]];
                            valueMap['code'] = bar['code'][l];

                            groupValues.push({
                                value: barValue.v[l].value,
                                map: valueMap,
                                type: 'bars'
                            });
                        }
                    }
                }

                if (group.type === 'lines') {
                    for (var m in group.lines) {
                        var line = group.lines[m];
                        var lineValue = line.values[groupIndex];

                        for (var o in lineValue.v) {
                            var valueMap = chartsData.values_map[line['code'][o]];
                            valueMap['code'] = line['code'][o];

                            groupValues.push({
                                value: lineValue.v[o].value,
                                map: valueMap,
                                type: 'lines'
                            });
                        }
                    }
                }
            }

            return groupValues;
        }

        var getTooltipContent = function (groupIndex) {
            var groupValues = getGroupDataByIndex(groupIndex);

            if (self.chartsData['prepareTooltipData']) {
                groupValues = self.chartsData['prepareTooltipData'](groupValues, groupIndex);
            }

            return nunjucks.render(self.chartTooltipUrl || "../hmodules/components/h-charts/partials/tooltip.njk", {
                groupValues: groupValues,
                format: self.chartsData.format['tooltip']
            });
        };

        var refreshTooltipContent = function () {
            if (tooltipElm) {
                var content = getTooltipContent(activeTooltipGroupIndex);
                tooltipElm.html(content);
            }
        };

        var showTooltip = function () {
            $('.h-charts-tooltip').remove();
            var content = getTooltipContent(activeTooltipGroupIndex);
            var elem = $('<div class="h-charts-tooltip">' + content + '</div>');
            tooltipElm = elem;
            $(self.appendChartTooltipTo || "body").append(elem);
            moveTooltipToEventLocation();
            isChartTooltipVisible = true;
        }

        var hideTooltip = function () {
            tooltipElm.remove();
            isChartTooltipVisible = false;
        };

        var handleTooltip = function () {
            if (mouseEvent) {
                if (!isChartTooltipVisible) {
                    showTooltip();
                }
                else {
                    moveTooltipToEventLocation();
                }
            }
            else if (isChartTooltipVisible) {
                hideTooltip();
            }
        }

        self.assignHandlers = function (element) {
            element.find('.chart-group').on('click', function (event) {
                var groupIndex = $(this).data("group-index");
                self.columnClicked(groupIndex);
                $scope.$apply();
            });

            element.find('.chart-group').on('mousemove mouseenter', function (event) {
                mouseEvent = event;

                if (!isChartTooltipVisible) {
                    activeTooltipGroupIndex = $(this).data("group-index");

                    if (!showTooltipTimeout) {
                        showTooltipTimeout = setTimeout(function () {
                            handleTooltip();
                        }, 100);
                    }
                }
                else {
                    if (activeTooltipGroupIndex != $(this).data("group-index")) {
                        activeTooltipGroupIndex = $(this).data("group-index");
                        refreshTooltipContent();
                    }

                    handleTooltip();
                }
            });

            element.find('.chart-group').on('mouseleave', function (event) {
                clearTimeout(hideTooltipTimeout);
                clearTimeout(showTooltipTimeout);

                hideTooltipTimeout = setTimeout(function () {
                    if (!mouseEvent) {
                        handleTooltip();
                    }
                }, 100);

                mouseEvent = null;
                showTooltipTimeout = null;
            });
        };

        self.columnClicked = function (index) {
            var groupData = getGroupDataByIndex(index);
            self.onBarClicked({ 'index': index, 'groupData': groupData });
        };

        var prepareData = function (chartsData) {
            chartsData = angular.copy(chartsData);
            var minValueType;
            var squareSideLength = self.viewPortHeight;
            if (self.viewPortHeight > self.viewPortWidth) {
                squareSideLength = self.viewPortWidth;
            }

            updateViewPortSize();

            var noData = true;

            var overallTotal = 0;
            if (isNaN(chartsData.column_spacing)) {
                chartsData.column_spacing = 30;
            }

            if (isNaN(chartsData.column_max_width_perc)) {
                chartsData.column_max_width_perc = 20;
            }

            if (isNaN(chartsData.y_axes_lines_count)) {
                chartsData.y_axes_lines_count = 10;
            }

            chartsData.y_axis = chartsData.y_axis || {
                primary: {}
            };

            for (var mapCode in chartsData.values_map) {
                chartsData.values_map[mapCode].axis = chartsData.values_map[mapCode].axis || 'primary';
            }

            if (!chartsData.format) {
                chartsData.format = {
                    default: {}
                }
            } else if (!chartsData.format['default']) {
                chartsData.format['default'] = {};
            }

            chartsData.format['tooltip'] = $.extend({compact: false}, chartsData.format['default'], chartsData.format['tooltip']);
            chartsData.format['bars_total'] = $.extend({compact: false}, chartsData.format['default'], chartsData.format['bars_total']);

            for (var i in chartsData['data']) {
                var group = chartsData['data'][i];

                if (group.type === 'bars') {
                    group.totalBarsWidth = 0;
                    group['bars_spacing'] = group['bars_spacing'] || 5;

                    for (var j in group.bars) {
                        var barAxisCode;
                        var bar = group.bars[j];
                        bar['width_weight'] = bar['width_weight'] || 1;

                        if (!angular.isArray(bar.code)) {
                            bar.code = [bar.code];
                        }

                        group.totalBarsWidth += bar['width_weight'];

                        for (var k in bar.values) {
                            var barValue = bar.values[k];
                            var totalBarValue = 0;

                            for (var l in barValue.v) {
                                noData = false;
                                barAxisCode = chartsData.values_map[bar['code'][l]]['axis'];

                                var previousIndex = parseInt(l) - 1;
                                barValue.v[l]['cumulative'] = 0;

                                if (!isNaN(barValue.v[l]['value'])) {
                                    totalBarValue += barValue.v[l]['value'];
                                }

                                if (previousIndex > -1) {
                                    barValue.v[l]['cumulative'] = barValue.v[previousIndex]['cumulative'] + barValue.v[previousIndex]['value'];
                                }
                            }

                            barValue.total = totalBarValue
                            overallTotal += totalBarValue;

                            chartsData.y_axis[barAxisCode] = chartsData.y_axis[barAxisCode] || {};
                            chartsData.y_axis[barAxisCode].maxValue = chartsData.y_axis[barAxisCode].maxValue || totalBarValue;

                            if (totalBarValue > chartsData.y_axis[barAxisCode].maxValue) {
                                chartsData.y_axis[barAxisCode].maxValue = totalBarValue;
                            }
                        }
                    }
                }

                if (group.type === 'lines') {

                    for (var m in group.lines) {
                        var lineAxisCode;
                        var line = group.lines[m];

                        if (!angular.isArray(line.code)) {
                            line.code = [line.code];
                        }

                        for (var n in line.values) {
                            var lineValue = line.values[n];
                            var totalLineValue = 0;

                            for (var o in lineValue.v) {
                                noData = false;
                                lineAxisCode = chartsData.values_map[line['code'][o]]['axis'];
                                totalLineValue += lineValue.v[o]['value'];
                            }

                            overallTotal += totalLineValue;

                            chartsData.y_axis[lineAxisCode] = chartsData.y_axis[lineAxisCode] || {};
                            chartsData.y_axis[lineAxisCode].maxValue = chartsData.y_axis[lineAxisCode].maxValue || totalLineValue;

                            if (totalLineValue > chartsData.y_axis[lineAxisCode].maxValue) {
                                chartsData.y_axis[lineAxisCode].maxValue = totalLineValue;
                            }
                        }
                    }
                }

                if (group.type === 'pies') {
                    group['squareSideLength'] = squareSideLength;
                    for (var p in group.pies) {
                        var pie = group.pies[p];
                        var radius = pie.radius || group.radius;

                        if (!angular.isArray(pie.code)) {
                            pie.code = [pie.code];
                        }
                        var totalPieValue = 0;
                        for (var q in pie.values) {
                            var pieValue = pie.values[q];

                            for (var r in pieValue.v) {
                                noData = false;
                                totalPieValue += pieValue.v[r]['value'];
                            }

                            var cumulativePercent = 0;

                            for (var r in pieValue.v) {
                                pieValue.v[r]['startPosition'] = getCoordinatesForPercent(cumulativePercent, radius, squareSideLength);
                                var slicePerc = pieValue.v[r]['value'] / totalPieValue;
                                cumulativePercent += slicePerc;
                                pieValue.v[r]['endPosition'] = getCoordinatesForPercent(cumulativePercent, radius, squareSideLength);
                                pieValue.v[r]['largeArcFlag'] = slicePerc > 0.5 ? 1 : 0;
                            }
                        }

                        overallTotal += totalPieValue;
                        pie.total = totalPieValue;
                    }
                }

                if (group.type === 'donuts') {
                    group['squareSideLength'] = squareSideLength;
                    for (var s in group.donuts) {
                        var donut = group.donuts[s];
                        var radius = donut.radius || group.radius;
                        var innerRadius = donut.innerRadius || group.innerRadius;

                        if (!angular.isArray(donut.code)) {
                            donut.code = [donut.code];
                        }
                        var totalDonutValue = 0;
                        for (var t in donut.values) {
                            var donutValue = donut.values[t];

                            for (var u in donutValue.v) {
                                noData = false;
                                totalDonutValue += donutValue.v[u]['value'];
                            }

                            var cumulativePercent = 0;

                            for (var v in donutValue.v) {
                                donutValue.v[v]['outerStartPosition'] = getCoordinatesForPercent(cumulativePercent, radius, squareSideLength);
                                donutValue.v[v]['innerStartPosition'] = getCoordinatesForPercent(cumulativePercent, innerRadius, squareSideLength);
                                var slicePerc = donutValue.v[v]['value'] / totalDonutValue;
                                cumulativePercent += slicePerc;
                                donutValue.v[v]['outerEndPosition'] = getCoordinatesForPercent(cumulativePercent, radius, squareSideLength);
                                donutValue.v[v]['innerEndPosition'] = getCoordinatesForPercent(cumulativePercent, innerRadius, squareSideLength);
                                donutValue.v[v]['largeArcFlag'] = slicePerc > 0.5 ? 1 : 0;
                            }
                        }

                        overallTotal += totalDonutValue;
                        donut.total = totalDonutValue;
                    }
                }
            }

            self.overallTotal = overallTotal;

            for (var axisCode in chartsData.y_axis) {
                chartsData.y_axis[axisCode].maxValue *= 1.2;
                chartsData.y_axis[axisCode].values = getYAxisValues(chartsData.y_axis[axisCode].maxValue, chartsData.y_axes_lines_count, chartsData.y_axes_lines_count_strict);
                chartsData.y_axis[axisCode].maxValue = chartsData.y_axis[axisCode].values[chartsData.y_axis[axisCode].values.length - 1];
            }

            chartsData.group_top_offset_perc = 0;
            chartsData.columns_title_position = chartsData.columns_title_position || 'bottom';
            if (chartsData.columns_title_position === 'top') {
                chartsData.group_top_offset_perc = 0.25;
            }

            self.noData = noData;
            return chartsData;
        };

        var getCoordinatesForPercent = function (percent, radius, sideLength) {
            var x = (radius * Math.cos(2 * Math.PI * percent)) + radius + ((sideLength / 2) - radius);
            var y = (radius * Math.sin(2 * Math.PI * percent)) + radius + ((sideLength / 2) - radius);
            return {
                x: x,
                y: y
            };
        };

        var getYAxisValues = function (maxValue, numberOfAxes, isStrict) {
            var step = self.chartData.y_axes_step || 1;
            var stepValue = isStrict ? step : (maxValue / numberOfAxes) || 1;
            var axisValues = [];
            var i = self.chartData.start_from_zero ? 0 : 1;

            for (; i <= numberOfAxes; i++) {
                axisValues.push(stepValue * i);
            }

            return axisValues;
        };

        self.$onInit = function () {
            if (self.chartData) {
                self.chartsData = prepareData(self.chartData);
            } else {
                self.noData = true;
            }
        };

        var clear = function () {
            clearTimeout(hideTooltipTimeout);
            clearTimeout(showTooltipTimeout);
            if (tooltipElm) {
                hideTooltip();
            }
        }


        var updateViewPortSize = function () {
            self.finalViewPortWidth = self.viewPortWidth;
            self.finalViewPortHeight = self.viewPortHeight;

            if (self.viewPortRatio === 'fixed-height') {
                if ($element && $element.find(".h-charts-component").length) {
                    var actualWidth = $element.find(".h-charts-component").width();

                    if (actualWidth) {
                        var widthRatio = actualWidth / self.viewPortWidth;
                        self.finalViewPortHeight = parseInt(self.viewPortHeight / widthRatio);
                    }
                }
            }
        };

        self.$onChanges = function (changesObj) {
            if (changesObj.chartData && !changesObj.chartData.isFirstChange()) {
                if (self.chartData) {
                    self.chartsData = prepareData(self.chartData);
                    self.triggerView = !self.triggerView;
                } else {
                    self.noData = true;
                }
            }

            if (changesObj.loading) {
                self.triggerView = !self.triggerView;
                if (self.loading) {
                    clear();
                }
            }

            if (
                (changesObj.viewPortWidth && !changesObj.viewPortWidth.isFirstChange()) ||
                (changesObj.viewPortHeight && !changesObj.viewPortHeight.isFirstChange())
            ) {
                updateViewPortSize();
                self.triggerView = !self.triggerView;
            }
        };

        self.$onDestroy = function () {
            clear();
        };

        self.$postLink = function () {

        }
    }

    var HChartsComponentOptions = {
        bindings: {
            chartData: "<",
            chartTitle: "@",
            viewPortWidth: "<",
            viewPortHeight: "<",
            viewPortRatio: "<",
            onBarClicked: '&',
            loading: '<',
            showPrimaryAxis: '<',
            showSecondaryAxis: '<',
            theme: '@',
            showLegend: '<',
            chartTooltipUrl: '<',
            appendChartTooltipTo: '@',
        },
        controller: HChartsComponent,
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-charts/h-charts.component.ng.html'
    };


    angular
        .module('components')
        .component('hCharts', HChartsComponentOptions);
})();